module.exports = __webpack_public_path__ + "static/03-88884718c7099f29859db0b53c3ae8dc.png";